var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import history from 'helpers/History';
import { loading } from 'elements/Loading';
import IconosApp, { Icono } from 'elements/IconosApp';
import theme, { mediaQueries } from 'Theme';
import cxs from 'cxs/component';
import History from 'helpers/History';
import { Text, View } from '../../../elements';
let OperationLinesList = class OperationLinesList extends Component {
    constructor() {
        super(...arguments);
        this.handleSelectItem = (value) => {
            history.push(`/operationlines/${value.id}`);
        };
        this.mapea = (values, businessUnits, receiptLayouts) => {
            return values.map(item => {
                const businessUnit = businessUnits.filter(ol => {
                    return ol.id === item.businessUnit_id;
                })[0];
                const operationLineString = 'businessUnit';
                item[operationLineString] = businessUnit ? businessUnit.name : '';
                const receiptLayout = receiptLayouts.filter(ol => {
                    return ol.id === item.receiptLayout_id;
                })[0];
                const receiptLayoutString = 'receiptLayout';
                item[receiptLayoutString] = receiptLayout ? receiptLayout.name : '';
                // console.log('item', item)
                return item;
            });
        };
    }
    componentDidMount() {
        console.log('componentDidMount');
        // this.props.store.operationLines.read()
        // this.props.store.businessUnits.read()
        // this.props.store.receipLayouts.read()
        const hasParent = (History.location.pathname.match(/\//g) || []).length >= 2;
        this.props.store.UI.changeHasParent(hasParent);
    }
    render() {
        var _a;
        // console.log('OperationLinesList - render()')
        let operationLines = (_a = this.props.operationLines) !== null && _a !== void 0 ? _a : [];
        const { businessUnits, receiptLayouts } = this.props;
        if (this.props.searchTerm) {
            // operationLines = Search(this.props.searchTerm, operationLines, ['name']) as OperationLine[]
            operationLines = operationLines.filter(value => value.name.toLowerCase().includes(this.props.searchTerm.toLowerCase()));
        }
        if (!((businessUnits === null || businessUnits === void 0 ? void 0 : businessUnits.length) > 0))
            return React.createElement("div", null,
                React.createElement("text", null, "No hay negocios dados de alta, por favor cree uno antes"));
        return (React.createElement(Wrapper, { flex: true, row: true }, operationLines === null || operationLines === void 0 ? void 0 : operationLines.map(operationline => React.createElement(WrapperItem, { flex: true, center: true, key: operationline.name, onClick: () => this.handleSelectItem(operationline) },
            !operationline.image && (React.createElement(IconosApp, { style: {
                    fontSize: '50px'
                }, name: Icono[operationline.icon] })),
            operationline.image && (React.createElement("img", { src: operationline.image, alt: `imagen ${operationline.name}`, style: {
                    height: '50px'
                } })),
            React.createElement(WrapperText, { center: true }, operationline.name)))));
    }
};
OperationLinesList = __decorate([
    inject('store'),
    observer,
    loading(props => {
        return [
            props.store.operationLines.read().then(operationLines => ({ operationLines })),
            props.store.businessUnits.read().then(businessUnits => ({ businessUnits })),
            props.store.receipLayouts.read().then(receiptLayouts => ({ receiptLayouts }))
        ];
    })
], OperationLinesList);
export default OperationLinesList;
const Wrapper = cxs(View)({
    position: 'relative',
    // height: '100%',
    // height: `${theme.common.devices.desktopHeight}px`,
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    ':hover': {
        color: theme.color.primary
    }
});
const WrapperItem = cxs(View)({
    justifyContent: 'center',
    alignItems: 'center',
    padding: '30px',
    margin: '10px',
    minWidth: '200px',
    maxWidth: '300px',
    height: '110px',
    border: `1px solid ${theme.color.secondary}`,
    borderRadius: '10px',
    [mediaQueries.mobile]: {
        minWidth: '40%',
        maxWidth: '50%'
    }
});
const WrapperText = cxs(Text)({
    flex: 1,
    fontSize: '12px'
    /*color: theme.color.secondary,*/
    /*':hover': {
      color: Theme.color.primary
    },*/
});



//////////////////
// WEBPACK FOOTER
// ./src/modules/OperationLines/container/OperationLinesList.tsx
// module id = 538
// module chunks = 0